// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

window.addEventListener('load', function () {
    console.log('JS swiper is geladen!');
    if (document.getElementById('productGallerySwiper')) {
        const swiper = new Swiper('#productGallerySwiper', {
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: false,
        });
        swiper.slideTo(0, 0, false); // Forceer naar eerste slide zonder animatie
        swiper.update();
    }
});

/*
// --- IntersectionObserver (versie 6 - Vaste waarde, geen meting) ---
window.addEventListener('load', function() {
    // Voer alleen uit op mobiele schermen
    if (window.innerWidth > 767) {
        return;
    }

    const stickyButton = document.querySelector('.juw-sticky-cart-btn');
    const stopElement = document.querySelector('.product-detail-tabs');
    const placeholder = document.querySelector('.product-detail-buy');

    if (!stickyButton || !stopElement || !placeholder) {
        console.error('Sticky-functionaliteit: Een of meerdere benodigde elementen niet gevonden.');
        return;
    }

    // Vaste waarde die overeenkomt met de SCSS-variabele.
    const placeholderHeight = '4.5rem';

    const pinButton = () => {
        if (!stickyButton.classList.contains('is-pinned')) {
            stickyButton.classList.add('is-pinned');
            stickyButton.classList.remove('is-docked');
            // Gebruik de vaste waarde voor de placeholder.
            placeholder.style.paddingBottom = placeholderHeight;
        }
    };

    const dockButton = () => {
        if (stickyButton.classList.contains('is-pinned')) {
            stickyButton.classList.remove('is-pinned');
            stickyButton.classList.add('is-docked');
            // Verwijder de placeholder padding.
            placeholder.style.paddingBottom = '0px';
        }
    };

    const observer = new IntersectionObserver(
        (entries) => {
            const [entry] = entries;
            if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
                dockButton();
            } else {
                pinButton();
            }
        },
        {
            root: null,
            threshold: 0,
        }
    );

    // Zet de initiële staat correct.
    pinButton();
    // Start de observer.
    observer.observe(stopElement);
});
*/